export const nfcInfo = [
  {
    key: 1,
    text: 'Created an login page , calulator, personal portfolio and Relevant projects related to frontend development',
  },
  {
    key: 2,
    text: 'Writing advanced SQL queries to maintain and extract data from the database ',
  },
  {
    key: 3,
    text: 'Create an attractive dashboard using power BI for the requirements as a data Analyst'
  },
];

export const ivoyantInfo = [
  {
    key: 1,
    text: 'Basically the internship started from excel basics to advanced where we had hands on session on pivot table and data mining',
  },
  {
    key: 2,
    text: 'Writing advanced SQL queries to maintain and extract data from the database',
  },
  {
    key: 3,
    text: 'Create an attractive dashboard using power BI for the requirements as a data Analyst',
  },

];


export const elitcelerInfo = [
  {
    key: 1,
    text: 'Developed Machine Learning Model where real time data was used to predict the car price prediction',
  },
  {
    key: 2,
    text: 'Learnt from Basics to advanced of HTML , CSS ,JS ,ReactJs and Bootstrap ',
  },
  {
    key: 3,
    text: 'Hands on traning with working professional in live projects used in company standarts ',
  },
];

export const tech = [
  {
    key: 1,
    text: 'Developved an e-commerce frontend and backend using MERN technology'
  },
  {
    key: 2,
    text: 'Used CRUD operations and postman to maintain the data with in the application'
  },

]
